import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Paper } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LegalPageLayout from "./shared/LegalPageLayout";

const ContactUs = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us - The Wart Guy</title>
        <meta
          name="description"
          content="Contact The Wart Guy team for questions, feedback or support."
        />
      </Helmet>

      <LegalPageLayout title="Contact Us">
        <p>
          Have questions, feedback, or need support? We'd love to hear from you.
          Please feel free to reach out to us.
        </p>

        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            backgroundColor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            padding: { xs: 2, sm: 3 },
            borderRadius: 2,
            marginTop: { xs: 2, sm: 3 },
            marginBottom: { xs: 2, sm: 3 },
            boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <EmailIcon
            sx={{
              fontSize: { xs: 32, sm: 40 },
              color: "primary.main",
              mt: { xs: 0.5, sm: 0 },
            }}
          />
          <Box>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                mb: 0.5,
              }}
            >
              Email Us
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              <a
                href="mailto:info@thewartguy.com"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                info@thewartguy.com
              </a>
            </Typography>
          </Box>
        </Box>

        <p>
          We aim to respond to all inquiries within 24-48 hours during business
          days. For medical emergencies, please contact your healthcare provider
          directly.
        </p>

        <Box
          sx={{
            mt: 4,
            p: { xs: 2, sm: 3 },
            bgcolor: "#f5f7f9",
            borderRadius: 2,
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1rem", sm: "1.1rem" },
              color: "text.primary",
            }}
          >
            Important Notice
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.8125rem", sm: "0.875rem" },
            }}
          >
            The information provided through our website and correspondence is
            for general informational purposes only and should not be considered
            medical advice. Always consult with a qualified healthcare
            professional for medical concerns.
          </Typography>
        </Box>
      </LegalPageLayout>
    </>
  );
};

export default ContactUs;
